import {combineReducers} from "@reduxjs/toolkit";
import {pipelineUIReducer} from "./entity/pipeline/pipeline-ui-store";
import {productionVolumeUIReducer} from "./entity/production-volume/production-volume-ui-store";
import {systemProcessExecutionUIReducer} from "./util/system-process-execution/system-process-execution-ui-store";
import {pipelineFlowUIReducer} from "./entity/pipeline-flow/pipeline-flow-ui-store";
import {pipelineFlowTransportUIReducer} from "./entity/pipeline-flow-transport/pipeline-flow-transport-ui-store";
import {activityPeriodUIReducer} from "./entity/activity-period/activity-period-ui-store";
import {meterFlowVolumeUIReducer} from "./entity/meter-flow-volume/meter-flow-volume-ui-store";
import {
  meterFlowVolumeReviewPageUIReducer
} from "./ui/meter-flow-volume-review-page/meter-flow-volume-review-page-store";
import {ticketComparePageUIReducer} from "./ui/ticket-compare-page/ticket-compare-page-store";
import {invoiceUIReducer} from "./entity/invoice/invoice-ui-store";
import {locationHistoryMapReducer} from "./ui/location-history-map-page/map-store";
import {settlementUIReducer} from "./entity/settlement/settlement-ui-store";
import {driverActivityPageReducer} from "./ui/driver-activity-page/driver-activity-page-store";
import {siteUIReducer} from "./entity/site/site-ui-store";
import {dvirUIReducer} from "./entity/dvir/dvir-ui-store";
import {restrictionUIReducer} from "./entity/restriction/restriction-ui-store";
import {chatPageReducer} from "./ui/chat-page/chat-page-store";
import {serviceEventUIReducer} from "./entity/service-event/service-event-ui-store";

export const otsUiReducers = {
  uiActivityPeriod: activityPeriodUIReducer,
  uiChatPage: chatPageReducer,
  uiDriverActivityPage: driverActivityPageReducer,
  uiDVIR: dvirUIReducer,
  uiInvoice: invoiceUIReducer,
  uiLocationHistoryMapPage: locationHistoryMapReducer,
  uiMeterFlowVolume: meterFlowVolumeUIReducer,
  uiMeterFlowVolumeReviewPage: meterFlowVolumeReviewPageUIReducer,
  uiPipeline: pipelineUIReducer,
  uiPipelineFlow: pipelineFlowUIReducer,
  uiPipelineFlowTransport: pipelineFlowTransportUIReducer,
  uiProductionVolume: productionVolumeUIReducer,
  uiRestriction: restrictionUIReducer,
  uiSettlement: settlementUIReducer,
  uiServiceEvent: serviceEventUIReducer,
  uiSite: siteUIReducer,
  uiSystemProcessExecution: systemProcessExecutionUIReducer,
  uiTicketComparePage: ticketComparePageUIReducer,
};

export const otsUiReducer = combineReducers(otsUiReducers);

export type OtsUIState = ReturnType<typeof otsUiReducer>;
